import { useTranslation } from "react-i18next"
import { Link, useSearchParams } from "react-router-dom"
import { ROUTES } from "@/helpers/routes"
import styles from "./OAuthError.module.scss"
import { oauthErrorMessageKey } from "./helpers"

export const OAuthError = () => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()

  return (
    <div className={styles.oauthError} role="alert">
      <p>{t(oauthErrorMessageKey(searchParams.get("reason")))}</p>
      <Link to={ROUTES.LOGIN}>{t("buttons.retry")}</Link>
    </div>
  )
}
